module.exports = (app) => app.controller('orderConfirmationTabController', /* @ngInject */ function ($scope, orderConfirmationService) {
    $scope.init = init;
    $scope.navigate = navigate;

    $scope.orderConfirmations = [];
    $scope.loading = false;

    /**
     * @type {string}
     */
    let orderNumber;

    function init(orderId) {
        orderNumber = orderId;
        getData(orderId)
    }

    function getData(orderId) {
        $scope.loading = true;
        orderConfirmationService.findAllForOrder(orderId).then((orderConfirmations) => {
            $scope.loading = false;
            if(orderConfirmations) {
                $scope.orderConfirmations = orderConfirmations;
            }
            $scope.$apply();
        }, () => {
            $scope.loading = false;
            $scope.$apply();
        })
    }

    function navigate(orderConfirmationId) {
        const route = `client/order/confirmation/${orderConfirmationId}`;
        const currentLocation = location.hash;
        setIFrameRoute(route);
        openContent( `container.htm&if=${route}`);
        determineBreadcrumbs(currentLocation);

    }

    function determineBreadcrumbs(currentLocation) {
        if(currentLocation.includes('my_order_show.htm')) {
            setMyShopBreadcrumbs();
        } else {
            setMyAdminBreadcrumbs()
        }

    }

    function setMyAdminBreadcrumbs() {
        setBreadcrumbs([
            new Breadcrumb('MyAdmin', '', 'my_adm/my_admin_main.htm'),
            new Breadcrumb('Transaktionen', '', ''),
            new Breadcrumb('Bestellungen', '', 'my_adm/order/my_adm_order_main.htm'),
            new Breadcrumb('Bestellung', '', `my_adm/order/my_adm_order_show.htm&VS_ORDER_ID=${orderNumber}`),
            new Breadcrumb('Auftragsbestätigung', '', ''),
        ]);
    }

    function setMyShopBreadcrumbs() {
        setBreadcrumbs([
            new Breadcrumb('MyShop', '', 'my_shop/my_shop_start.htm'),
            new Breadcrumb('Ihre Bestellungen', '', 'my_shop/my_order/my_order_list.htm'),
            new Breadcrumb('Bestellung', '', `my_shop/my_order/my_order_show.htm&VS_ORDER_ID=${orderNumber}&NEW=TRUE&BACK_LINK=my_shop/my_order/my_order_list.htm`),
            new Breadcrumb('Auftragsbestätigung', '', ''),
        ]);
    }
});